import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getProduct, getProfile } from "../redux/action";
import "../css/main.css";
import { Dna } from "react-loader-spinner";

function Product({ login, setlogin }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    data,
    loading,
    error: errorProduct,
  } = useSelector((state) => state.Product);
  const { error: errorProfile } = useSelector((state) => state.Profile);
  const storageUser = JSON.parse(localStorage.getItem("User"));

  useEffect(() => {
    dispatch(getProduct());
    if (storageUser && login) {
      dispatch(getProfile());
    }
    if (login && errorProfile) {
      console.log(login);
      setlogin(false);
      localStorage.removeItem("User");
    }
  }, []);
  return (
    <div className="mt-20 flex-wrap flex justify-around">
      {loading ? (
        <div className="mt-32 flex justify-center">
          <Dna
            visible={true}
            height="150"
            width="150"
            ariaLabel="dna-loading"
            wrapperStyle={{}}
            wrapperClass="dna-wrapper"
          />
        </div>
      ) : errorProduct ? (
        <div className="flex justify-center">
          <div className="alert alert-error shadow-lg w-8/12 mt-20">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="stroke-current flex-shrink-0 h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span>Error! Task failed successfully.</span>
            </div>
          </div>
        </div>
      ) : (
        data.map((item, index) => {
          return (
            <div
              className="card w-96 bg-gray-800 border border-x-gray-600 shadow-xl m-5 cursor-pointer hover:shadow-2xl hover:scale-105 transition-all duration-300 overflow-hidden"
              key={index}
            >
              <div
                onClick={() =>
                  navigate("/ProductId", {
                    state: item._id,
                  })
                }
              >
                <figure className="bg-white h-60">
                  <img src={item.image} className="w-32" alt="image" />
                </figure>
                <div className="card-body text-gray-200">
                  <h2 className="text-2xl font-semibold mb-20">{item.name}</h2>
                  {item.countInStock == 0 ? (
                    <p className="text-red-600 text-xl">
                      There is no inventory
                    </p>
                  ) : (
                    <p className="absolute bottom-14 right-0 w-full">
                      countInStock :{" "}
                      <span className="text-red-600 text-xl">
                        {item.countInStock}
                      </span>
                    </p>
                  )}
                  <div className="flex justify-around absolute w-full bottom-5 right-0">
                    <span className="">
                      Price :{" "}
                      <span className="text-green-700 text-lg">
                        {item.price} $
                      </span>
                    </span>
                    <span className="">
                      Rating :{" "}
                      <span className="text-amber-500 text-lg">
                        {item.rating}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}

export default Product;
